import { bannerTypes } from '../constants/constants';
import { newRelicConstants } from '../constants';

export const triggerNewRelic = (adType, eventType) => {
  if (typeof window !== 'undefined') {
    if (!window.sponsoredContent) {
      window.sponsoredContent = {};
    }

    if (window.newrelic && typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      window.LIFE_CYCLE_EVENT_BUS.trigger('sponsored-content.event', { adType, event: eventType });
      window.sponsoredContent[adType] = true;
    }
  }
};

export const getNewRelicConstant = (bannerType) => {
  if (bannerType === bannerTypes.HERO) {
    return newRelicConstants.HERO_BANNER;
  }
  if (bannerType === bannerTypes.SKYSCRAPER) {
    return newRelicConstants.SKYSCRAPER_BANNER;
  }
  if (bannerType === bannerTypes.MIDDLE) {
    return newRelicConstants.PIP_BANNER;
  }
  if (bannerType === bannerTypes.STANDARD || bannerType === 'sponsored__banner' || bannerType === 'auth__banner') {
    return newRelicConstants.STANDARD_BANNER;
  }
  if (bannerType === bannerTypes.INGRID) {
    return newRelicConstants.INGRID_BANNER;
  }
  if (bannerType === bannerTypes.LEADERBOARD) {
    return newRelicConstants.LEADERBOARD_BANNER;
  }
  return null;
};

export const triggerNewRelicTimeLog = (componentName, startTime, endTime, adServer = '') => {
  if (!window.sponsoredContent) {
    window.sponsoredContent = {};
  }

  if (window.newrelic && typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS.trigger('performance.component-load', {
      componentName: `${componentName}${adServer ? `-${adServer.toLowerCase()}` : ''}`,
      startTime,
      endTime,
    });

    window.sponsoredContent[componentName] = true;
  }
};

export const onTriggerNewRelicAdBlocked = (adType) => {
  if (!adType) return;
  triggerNewRelic(adType, newRelicConstants.AD_BLOCKED);
};

export const triggerTargetingInputsMetric = ({
  schema, bannerType, hasMatchProducts, hasCustomerIdentifier, implementation
}) => {
  triggerNewRelic(`targetingInputs.hasMatchProducts.${bannerType}.${schema}.${implementation}`, hasMatchProducts);
  triggerNewRelic(`targetingInputs.hasCustomerIdentifier.${bannerType}.${schema}.${implementation}`, hasCustomerIdentifier);
};

export function triggerAdTimeLogs(dataTestId, adLoadStartTime, bannerInitTime, innervateScriptTime, beaconAddTime, impressionFiredTime, adServer) {
  const timeLogMapping = {
    'sponsored-standard-banner': {
      adLoad: newRelicConstants.STANDARD_BANNER_AD_LOAD_TO_IMPRESSION,
      bannerInit: newRelicConstants.STANDARD_BANNER_AD_INIT_TO_IMPRESSION,
      innervateScript: newRelicConstants.STANDARD_BANNER_AD_INNERVATE_SCRIPT_TO_IMPRESSION,
      beaconAdd: newRelicConstants.STANDARD_BANNER_AD_BEACON_ADDED_TO_IMPRESSION
    },
    'sponsored-skyscraper-banner': {
      adLoad: newRelicConstants.SKYSCRAPER_BANNER_AD_LOAD_TO_IMPRESSION,
      bannerInit: newRelicConstants.SKYSCRAPER_BANNER_AD_INIT_TO_IMPRESSION,
      innervateScript: newRelicConstants.SKYSCRAPER_BANNER_AD_INNERVATE_SCRIPT_TO_IMPRESSION,
      beaconAdd: newRelicConstants.SKYSCRAPER_BANNER_AD_BEACON_ADDED_TO_IMPRESSION
    },
    'sponsored-pip-banner': {
      adLoad: newRelicConstants.PIP_BANNER_AD_LOAD_TO_IMPRESSION,
      bannerInit: newRelicConstants.PIP_BANNER_AD_INIT_TO_IMPRESSION,
      innervateScript: newRelicConstants.PIP_BANNER_AD_INNERVATE_SCRIPT_TO_IMPRESSION,
      beaconAdd: newRelicConstants.PIP_BANNER_AD_BEACON_ADDED_TO_IMPRESSION
    },
    'sponsored-ingrid-banner': {
      adLoad: newRelicConstants.INGRID_BANNER_AD_LOAD_TO_IMPRESSION,
      bannerInit: newRelicConstants.INGRID_BANNER_AD_INIT_TO_IMPRESSION,
      innervateScript: newRelicConstants.INGRID_BANNER_AD_INNERVATE_SCRIPT_TO_IMPRESSION,
      beaconAdd: newRelicConstants.INGRID_BANNER_AD_BEACON_ADDED_TO_IMPRESSION
    },
    'sponsored-hero-banner': {
      adLoad: newRelicConstants.HERO_BANNER_AD_LOAD_TO_IMPRESSION,
      bannerInit: newRelicConstants.HERO_BANNER_AD_INIT_TO_IMPRESSION,
      innervateScript: newRelicConstants.HERO_BANNER_AD_INNERVATE_SCRIPT_TO_IMPRESSION,
      beaconAdd: newRelicConstants.HERO_BANNER_AD_BEACON_ADDED_TO_IMPRESSION
    },
    'sponsored-leaderboard-banner': {
      adLoad: newRelicConstants.LEADERBOARD_BANNER_AD_LOAD_TO_IMPRESSION,
      bannerInit: newRelicConstants.LEADERBOARD_BANNER_AD_INIT_TO_IMPRESSION,
      innervateScript: newRelicConstants.LEADERBOARD_BANNER_AD_INNERVATE_SCRIPT_TO_IMPRESSION,
      beaconAdd: newRelicConstants.LEADERBOARD_BANNER_AD_BEACON_ADDED_TO_IMPRESSION
    }
  };

  const timeLogs = timeLogMapping[dataTestId];
  if (timeLogs) {
    if (adLoadStartTime) {
      triggerNewRelicTimeLog(timeLogs.adLoad, adLoadStartTime, impressionFiredTime, adServer);
    }
    if (bannerInitTime) {
      triggerNewRelicTimeLog(timeLogs.bannerInit, bannerInitTime, impressionFiredTime, adServer);
    }
    if (innervateScriptTime) {
      triggerNewRelicTimeLog(timeLogs.innervateScript, innervateScriptTime, impressionFiredTime, adServer);
    }
    if (beaconAddTime) {
      triggerNewRelicTimeLog(timeLogs.beaconAdd, beaconAddTime, impressionFiredTime, adServer);
    }
  }

}
